import { render, staticRenderFns } from "./form_transfor.vue?vue&type=template&id=c0ce7472&scoped=true"
import script from "./form_transfor.vue?vue&type=script&lang=js"
export * from "./form_transfor.vue?vue&type=script&lang=js"
import style0 from "./form_transfor.vue?vue&type=style&index=0&id=c0ce7472&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ce7472",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0ce7472')) {
      api.createRecord('c0ce7472', component.options)
    } else {
      api.reload('c0ce7472', component.options)
    }
    module.hot.accept("./form_transfor.vue?vue&type=template&id=c0ce7472&scoped=true", function () {
      api.rerender('c0ce7472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/visit_manage/visit_step/form/components/form_transfor.vue"
export default component.exports